import { render, staticRenderFns } from "./MarkdownDisplay.vue?vue&type=template&id=1bcefe80&"
import script from "./MarkdownDisplay.vue?vue&type=script&lang=js&"
export * from "./MarkdownDisplay.vue?vue&type=script&lang=js&"
import style0 from "./MarkdownDisplay.vue?vue&type=style&index=0&id=1bcefe80&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports